import { Modal, Typography } from 'antd'
import React from 'react'
import dayjs from 'dayjs'
import { ICommissionDiscount } from 'models/seller'

interface CommissionDiscountModalProps {
  discount: ICommissionDiscount | null
  onClose: () => void
}

export const CommissionDiscountModal: React.FC<CommissionDiscountModalProps> = ({
  discount,
  onClose
}) => {
  const until = discount?.end_date
    ? dayjs(discount.end_date).format('DD.MM.YYYY')
    : null

  return (
    <Modal
      open={Boolean(discount)}
      centered
      width='fit-content'
      onCancel={onClose}
      onOk={onClose}
      okText='Хорошо'
      cancelButtonProps={{ style: { display: 'none' } }}
      title='Снижение комиссии'
    >
      <Typography.Text>
        Вам снижена комиссия — {discount?.rate}%{until ? ` до ${until}` : ''}.
      </Typography.Text>
    </Modal>
  )
}
